import { LegalPage } from "./legal/LegalPage";
import PrivacyDocument from "./dynamic/Privacy";

export default function PrivacyComponent() {
  return (
    <LegalPage path="/privacy">
      <PrivacyDocument />
    </LegalPage>
  );
}
